<template>
	<div v-if="context" class="space-y-4">
		<nk-link
			v-if="context.detailURL && context.bild"
			block
			:link="context.detailURL"
		>
			<nk-image
				v-if="context.bild"
				:copyright="context.bildcopyright"
				:src="context.bild"
				ar="21:9"
				:alt="context.bildtext"
			/>
		</nk-link>
		<nk-image
			v-else-if="context.bild"
			:copyright="context.bildcopyright"
			:src="context.bild"
			ar="21:9"
			:alt="context.bildtext"
		/>
		<nk-box v-if="context.titel || context.einleitung" variant="sidebar">
			<nk-title v-if="context.detailURL && context.titel" size="lg">
				<nk-link :link="context.detailURL">
					{{ context.titel }}
				</nk-link>
			</nk-title>

			<nk-title v-else-if="context.titel" size="lg">
				{{ context.titel }}
			</nk-title>

			<nk-text v-if="context.einleitung">
				{{ context.einleitung }}
			</nk-text>
		</nk-box>
	</div>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {object} context
 */
export default {
	name: 'NkSidebarArtikel',

	mixins: [TemplatesDefault],
};
</script>
